import {ScriptLoaderService} from "../../../services/script-loader.service";
import {GtmService} from "../services/gtm.service";
import {AbstractInitializer} from "../../../initializers/abstract.initializer";
import {inject, Injectable, Renderer2} from "@angular/core";
import {Observable, of} from "rxjs";

@Injectable({
	providedIn: "root"
})
export class GtmInitializer extends AbstractInitializer {

	private readonly scriptLoaderService: ScriptLoaderService = inject(ScriptLoaderService);
	private readonly gtmService: GtmService = inject(GtmService);
	private readonly renderer: Renderer2 = inject(Renderer2);

	public override initalize(gtmConfig: any): Observable<boolean> {
		if (gtmConfig) {
			const query = `id=${gtmConfig.containerId}&gtm_auth=${gtmConfig.gtmAuth}&gtm_preview=${gtmConfig.gtmPreview}`;
			this.scriptLoaderService.loadScript({
				src: `https://www.googletagmanager.com/gtm.js?${query}`,
				async: true,
				type: 'text/javascript',
				charset: 'utf-8'
			}, this.renderer).then((isLoaded: boolean) => {
				if (isLoaded) {
					this.gtmService.pushToDataLayer({
						"gtm.start": new Date().getTime(),
						event: "gtm.js"
					});
				}
			});
		}
		return of(true);
	}
}